export const APP_VERSION = "v1.1.0";